import React from 'react'
import t from '~t'

import { HeaderTitle as Title, Header } from '~ui'
import CollectionIcon from '~co/collections/item/icon'

export default function BookmarksHeaderSelectModeLoading({ selectMode = {} }) {
    const { working } = selectMode
    const strings = {
        move: t.s('move'),
        important: t.s('addToFavorites'),
        importantRemove: t.s('removeFromFavorites'),
        screenshot: t.s('clickToMakeScreenshot'),
        removeTags: t.s('removeTags'),
        reparse: t.s('refreshPreview'),
        remove: t.s('remove')
    }

    return (
        <Header>
            <CollectionIcon loading={true} />

            <Title>
                {strings[working] || t.s('loading')}…
            </Title>
        </Header>
    )
}
